document.addEventListener('DOMContentLoaded', () => {
    let tp_claim_intimation_back_btn = document.querySelector('#tp_claim_intimation_back_button');
    if (tp_claim_intimation_back_btn !== null) {
        tp_claim_intimation_back_btn.addEventListener("click", function (e) {
            e.preventDefault();
            parent.location = location.protocol + '//' + location.host + location.pathname + window.location.search.replace('&commit=Search', '');
        });
    }
});
